import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../base';

@Injectable()
export class LoadFileService extends ApiService {
  fileUpload(formData: any): Observable<any> {
    return this.post('/platform/api/storages/file-upload', formData, {
      reportProgress: true,
      observe: 'events',
    });
  }
}
